import React, {useState} from "react"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import {reActivateCard, BusinessDebitCard, IndividualDebitCard} from "../../resources/card"
import {BusinessCustomer, IndividualCustomer} from "../../resources/customer"
import Admonition from "../Admonitions/Admonition"
import classNames from "classnames"
import Icon from "../Icon/Icon"

interface ReactivateCardModalProps {
	card: BusinessDebitCard | IndividualDebitCard
	close: () => void
	onSuccess: () => void
	customer?: IndividualCustomer | BusinessCustomer
}

function refreshAndClose(refresh: () => void, close: () => void) {
	return function () {
		refresh()
		close()
	}
}

function ReactivateCardSuccess() {
	return (
		<div className={"card-action-success"}>
			<div className={"card-action-success-icon-placeholder"}>
				<Icon icon={"credit-card-check-approved--business-products"} size={32} />
			</div>
			<h3>Card reactivated successfully!</h3>
		</div>
	)
}

export function ReactivateCardModal({card, close, onSuccess}: ReactivateCardModalProps) {
	const accessToken = useAccessToken()
	const [reactivateState, setReactivateState] = useAsyncResultIdle(reActivateCard)
	const [isResult, receiveResult] = useState(false)

	return (
		<AsyncResultModal
			title="Reactivate Card"
			classname={classNames("card-action-modal", isResult && "card-action-modal-final")}
			close={refreshAndClose(onSuccess, close)}
			buttonClassname="is-black"
			blockBodyScroll={true}
			state={reactivateState}
			okComponent={<ReactivateCardSuccess />}
			disableCloseOnSuccess={true}
			buttonText="Reactivate Card"
			successText="Done"
			enableClickAway={false}
			onSubmit={() => {
				setReactivateState(accessToken, card).then(() => {
					receiveResult(true)
				})
			}}
			errorToText={(err) => err.errors[0].title}
		>
			<Admonition
				type={"is-warning"}
				message={
					<p>
						{" "}
						The card has been flagged for high fraud risk. You should only reactivate it if you have confirmed with the
						cardholder that all previous activity on the card is not fraudulent. Are you sure you want to reactivate the
						card?{" "}
					</p>
				}
				title={"Note"}
			/>
		</AsyncResultModal>
	)
}
